<template>
    <div class="u-d-flex">
            <div class="flex-grid__item--third">
                <div class="u-margin-bottom-20 u-bold">
                    Date Received
                </div>
                <control for="paymentDate" :table-control="true" :icon-space="false">
                    <date-input
                            required
                            v-field-control:paymentDate.required="{type:'date'}"
                            v-model="payment.date"
                            @input="updateValid()">
                    </date-input>
                    <control-error :show="paymentDateInvalid">
                        Payment date must be on or after the date of injury ({{ periodStart }}) and a valid date.
                    </control-error>
                </control>
            </div>
            <div class="flex-grid__item--third">
                <div class="u-margin-bottom-20 u-bold">
                    Payment
                </div>
                <control for="payment_total" :table-control="true" :icon-space="false" before-after="pound">
                    <input type="number"
                           v-model.number="payment.total"
                           class="payment-received"
                           @input="updateValid()"
                           v-two-dp
                    >
                    <control-error :show="paymentTotalInvalid">
                        Payment must be greater than &pound;0.
                    </control-error>
                </control>
            </div>
            <div class="flex-grid__item--third u-margin-top-40">
                <button class="a-button a-button--small" @click="removePayment()">Delete Payment</button>
            </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Control from 'components/form/Control';
    import ControlError from 'components/form/control/Error';
    import ControlWarning from 'components/form/control/Warning.vue';
    import DateInput from 'components/form/control/DateInput.vue';
    import FormValidator from 'components/form/validator/mixin';
    import currencyFormat from 'mixins/currencyFormat';
    import moment from 'moment';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        name: 'post-accident-earnings',
        props: {
            payment:{
                type: Object,
                required: true
            },
            paymentIndex:{
                type: Number,
                required: true
            },
            periodIndex:{
                type: Number,
                required: true
            },
            periodStart:{
                type: String,
                required: true
            },
            periodEnd:{
                type: String,
                required: true
            },
        },
        components: {
            Control,
            ControlError,
            ControlWarning,
            DateInput,
            moment
        },
        mixins: [
            currencyFormat,
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('personal/claimant', [
                'getClaimInfo'
            ]),
            paymentDateInvalid: {
                get() {
                    if (!this.payment.date) {
                        return true;
                    }

                    let paymentDate = moment(this.payment.date, "DD/MM/YYYY");
                    let dateOfInjury = moment(this.getClaimInfo('dateOfInjury'), "DD/MM/YYYY");

                    return paymentDate.isSameOrAfter(dateOfInjury) ? false : true;
                }
            },
            paymentTotalInvalid: {
                get() {
                    if (!this.payment.total) {
                        return true;
                    }

                    return (this.payment.total < 1);
                }
            },
        },
        methods: {
            ...mapActions('personal/claimant', [
                'removePostInjuryPayment'
            ]),
            removePayment() {
                this.removePostInjuryPayment({
                    period: this.periodIndex,
                    payment: this.paymentIndex
                })
            },
            isValid() {
                return (!this.paymentDateInvalid && this.payment.total > 0) ;
            },
            updateValid() {
                this.$emit('update', {paymentValid: this.isValid()});
            }
        }
    }

</script>


// WEBPACK FOOTER //
// PostAccidentPayments.vue?2d6115ae